module.exports = __webpack_public_path__ + "media/theme/twitter-23585d94.png";